import gql from 'graphql-tag';

export const readSelectedEvidenceQuery = gql`
  query ReadSelectedEvidence($ids: [Int!]!) {
    response: readSelectedEvidence(
      ids: $ids
    ) {
      id
      pole{
        id
        data
        vstupni_pole_id
      }
      kategorie {
        id
      }
      autor_id
    }
  }
`;
